import React, { SVGProps } from 'react';

const IconTiStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.246712 9.94539H0.0424805V5.59741H12.5036V9.94539H12.3075C11.1149 9.94539 9.92228 9.94539 8.72966 9.94539C8.51313 9.94539 8.51255 9.94539 8.51255 10.1613C8.51255 12.9954 8.51255 15.8301 8.51255 18.6642V18.9234C8.43589 18.8883 8.38673 18.8702 8.34167 18.8444C6.95711 18.0427 5.57372 17.2392 4.1874 16.441C4.07036 16.3737 4.03408 16.2965 4.03466 16.166C4.03876 14.1769 4.03759 12.1878 4.037 10.1994C4.037 9.91554 4.05924 9.94714 3.79181 9.94656C2.6103 9.94539 1.4288 9.94656 0.246712 9.94656V9.94539ZM0.0424805 19.3529V23.6869H12.5036V19.3529H0.0424805Z"
      fill="#F32A52"
    />
    <path
      d="M14.7165 6.0833C14.8245 6.0833 14.9055 5.99336 14.9055 5.89442C14.9055 4.60825 15.9491 3.57391 17.2266 3.57391C17.3345 3.57391 17.4155 3.48397 17.4155 3.38503C17.4155 3.2861 17.3255 3.19616 17.2266 3.19616C15.9491 3.19616 14.9055 2.15283 14.9055 0.875645C14.9055 0.767715 14.8155 0.686768 14.7165 0.686768C14.6176 0.686768 14.5276 0.776709 14.5276 0.875645C14.5276 2.16182 13.484 3.19616 12.2065 3.19616C12.0985 3.19616 12.0176 3.2861 12.0176 3.38503C12.0176 3.48397 12.1075 3.57391 12.2065 3.57391C13.493 3.57391 14.5276 4.61724 14.5276 5.89442C14.5276 6.00235 14.6176 6.0833 14.7165 6.0833Z"
      fill="#C6A26C"
    />
  </svg>
);

export default IconTiStar;
